import { render } from "./OpenGymAbout.vue?vue&type=template&id=d4ecc7d4&scoped=true"
import script from "./OpenGymAbout.vue?vue&type=script&lang=js"
export * from "./OpenGymAbout.vue?vue&type=script&lang=js"

import "./OpenGymAbout.vue?vue&type=style&index=0&id=d4ecc7d4&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4ecc7d4"]])

export default __exports__